import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 4.062C6.89401 4.57928 3.86031 8.14271 4.00483 12.2786C4.14935 16.4145 7.42437 19.7575 11.5565 19.987C15.6885 20.2164 19.3135 17.2565 19.915 13.162V13.146V13.117V13.087V13.058V13.042V13.031V13.017V13H11V4.062ZM13 4.062V11H19.938C19.4815 7.37411 16.6259 4.51851 13 4.062Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "PieChartOutline25"
);
